export default function (state, getters, rootState, rootGetters) {
    let form = getters.form;
    let data = {};

    if (!form.ContragentId || !state.Sum) return;
    data.CertificateId = form.Id;
    data.PaymentDirection = 0;
    data.Direction = 1;
    data.PaymentOperationID = state.PaymentOperationID;
    data.PaymentTypeId = state.PaymentTypeId;
    data.ContragentType = getters.c_type;
    data.ContragentID = form.ContragentId;
    if (!form.ContragentId) {
        window.app.$notify.warning({
            message: 'Необходимо указать контрагента',
        });
        return;
    }
    data.Sum = state.Sum;
    data.BankCommission = state.BankCommission;
    data.CurrencyId = form.CurrencyId;
    if (data.ContragentType === 2) {
        data.PartnerLegalEntityId = state.PartnerLegalId;
    }

    data.CategoryId = state.CategoryId;
    switch (state.CategoryId) {
        case 0:
            data.CashId = state.CashId;
            break;
        case 1:
            data.PaymentAccountId = state.PaymentAccountId;
            break;
    }
  debugger;
    data.DocumentNumber = state.DocumentNumber;
    data.PaymentDate = {"Serialized": state.PaymentDate};
    data.AccountNumber = state.AccountNumber;
    data.PaymentDetails = state.PaymentDetails;


    // form.AgreementCodes.forEach(i => {
    //     ags.push(getters['agreements/agreement'](i));
    // });
    // let ags = [];
    // ags.forEach(i => {
    //     let item = {};
    //     item.Code = i.code;
    //     item.Comment = i.comment;
    //     item.Course = i.course;
    //     item.TargetCurrencyId = 0;
    //     item.Spread = 0;
    //     if (form.ContragentType === 3) item.OrderPrices = [];
    //     item.Date = {Serialized: i.date, Format: "dd.MM.yyyy"};
    //     i.requests.forEach(j => {
    //         item.Course = (j.currency !== data.CurrencyId && form.CategoryId !== 2) ? i.course : 1;
    //         item.TargetCurrencyId = j.currency;
    //         item.Spread += Math.round(item.Course * j.sum * 100) / 100;
    //         if (form.ContragentType === 3) {
    //             item.OrderPrices.push({
    //                 RequestId: j.value,
    //                 Spread: Math.round(item.Course * j.sum * 100) / 100,
    //             });
    //         }
    //     });
    //     data.PaymentDetails.push(item);
    // });

    if (state.Id) data.Id = state.Id;
    return data;
}